import { FiInfo } from "../../assets/icons/vander";

export const ResultEvaluationPatient = ({
  track,
  dasiScore,
  mets,
  cRisk,
  asa,
  Cfs,
  allergies,
  procedure,
  description,
  state,
}) => {
  return (
    <>
      <div className="card border-0 shadow rounded p-4 mb-4">
        <h6 className="mb-0">
          Procedimiento:{" "}
          {procedure?.procedureParentName
            ? `${procedure.procedureParentName}`
            : procedure.title}
        </h6>
        <p className="text-muted mb-0 text-truncate small">
          Propósito: {procedure.title}
        </p>
        <ul className="list-unstyled mb-0 mt-2">
          {description && (
            <li className="d-flex ms-0">
              <h6>Descripción:</h6>
              <p className="text-muted ms-2">{description}</p>
            </li>
          )}
        </ul>
      </div>

      {state !== "QUIZ_SEND" ? (
        <div className="table-responsive shadow rounded">
          <table className="table table-center bg-white mb-0">
            <thead className="table-primary">
              <tr>
                <th className="border-bottom p-3">Indicador</th>
                <th className="border-bottom p-3">Resultado</th>
              </tr>
            </thead>
            <tbody>
              {track && (
                <tr>
                  <td className="py-3">Riesgo</td>
                  <td className="py-3">{track}</td>
                </tr>
              )}
              {dasiScore && (
                <tr>
                  <td className="py-3">Dasi Score</td>
                  <td className="py-3">{dasiScore}</td>
                </tr>
              )}
              {mets && (
                <tr>
                  <td className="py-3">Mets</td>
                  <td className={`py-3 ${mets >= 4 ? "text-underline-success" : "text-underline-danger" }`}>{mets}</td>
                </tr>
              )}
              {cRisk && (
                <tr>
                  <td className="py-3">Riesgo cardiovascular</td>
                  <td className={`py-3 ${cRisk <= 6 ? "text-underline-success" : "text-underline-danger" }`}>{cRisk}</td>
                </tr>
              )}
              {asa && (
                <tr>
                  <td className="py-3">Clasificación ASA</td>
                  <td className="py-3">{asa}</td>
                </tr>
              )}

              {Cfs && (
                <tr>
                  <td className="py-3">Escala de fragilidad</td>
                  <td className="py-3">{Cfs}</td>
                </tr>
              )}

              {allergies && (
                <tr>
                  <td className="py-3">Alergias</td>
                  <td className="py-3">{allergies}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert bg-soft-yellow fw-medium" role="alert">
          <FiInfo className="fs-5 align-middle me-1" /> El paciente no presenta
          resultados
        </div>
      )}
    </>
  );
};
